import React from 'react';
import ForwardingBatch from '../Forwarding/Pages/ForwardingBatch';
import ForwardingBatches from '../Forwarding/Pages/ForwardingBatches';
import Mailboxes from './Pages/Mailboxes';
import MailItem from '../MailItem/Pages/MailItem';
import ForwardingBatchProvider from '../Forwarding/Providers/ForwardingBatchProvider';
import MailboxesSearch from './Pages/MailboxesSearch';
import { SuggestibleRouteInterface } from '../_Global/Types/RouteTypes';

const MailRoutes: Array<SuggestibleRouteInterface> = [
	{
		title: 'Mailboxes',
		path: '/mail/:folderSlug?',
		element: <Mailboxes />,
	},
	{
		title: 'Forwarding Batches',
		path: '/mail/forwarding-batches',
		element: <ForwardingBatches />,
	},
	{
		title: 'Forwarding Batches',
		path: '/mail/forwarding-batches/:batchId',
		element: (
			<ForwardingBatchProvider>
				<ForwardingBatch />
			</ForwardingBatchProvider>
		),
	},
	{
		title: 'Custom Folder',
		path: '/mail/custom-folder/:clientFolderIds',
		element: <Mailboxes />,
	},
	{
		title: 'Search Mailboxes',
		path: `/mail/search`,
		element: <MailboxesSearch />,
	},
	{
		title: 'Mailboxes Item',
		path: `/mail/:folderSlug/:mailId`,
		element: <MailItem />,
	},
	{
		title: 'Mailboxes Item',
		path: `/mail/forwarding-batches/mail-item/:mailId`,
		element: <MailItem />,
	},
	{
		title: 'Mailboxes Item',
		path: `/mail/custom-folder/:customFolderId/:mailId`,
		element: <MailItem />,
	},
];

export default MailRoutes;
